import React from 'react'

import Favicon from '../../Favicon'

export interface IconItem {
  type: 'icon'
  name?: string
  url?: string
}

export const BreadcrumbIcon = ({ name, url }: IconItem): JSX.Element => <Favicon name={name} src={url} sx={{}} />
